import { Typography } from '@mui/material';
import { isNil } from 'lodash';
import { useContext } from 'react';
import { To, useNavigate } from 'react-router-dom';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { lang } from 'src/utils';

import { AuthDataProvider } from '../authProvider';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { BreadcrumbsProps } from './Breadcrumbs';
import { StyledLink, StyledText } from './Breadcrumbs.styled';

export interface BreadcrumbsItemProps {
  label: string;
  link?: string | number;
}

export const BreadcrumbsItem = ({
  props,
  item,
  index,
}: {
  props: BreadcrumbsProps;
  item: BreadcrumbsItemProps;
  index: number;
}) => {
  const navigate = useNavigate();
  const { userRole } = useContext(AuthDataProvider);
  const linkDisable =
    isNil(item.link) ||
    (userRole === AuthClassification.OWNER_OPERATOR &&
      item.label === lang.assemblies);

  return index !== props.items.length - 1 ? (
    <StyledLink
      data-testid={`breadcrumbsItem-${index}`}
      underline={item.link ? 'hover' : 'none'}
      color={'secondary.main'}
      $linkDisable={linkDisable}
      onClick={() => item.link && navigate(item.link as To)}>
      <CustomTooltip
        width={500}
        placement="bottom"
        title={item.label}
        overflowWidth={250}>
        <StyledText color={'secondary.main'} $linkDisable={linkDisable}>
          {item.label}
        </StyledText>
      </CustomTooltip>
    </StyledLink>
  ) : (
    <CustomTooltip
      width={500}
      placement="bottom"
      title={item.label}
      overflowWidth={250}>
      <Typography key={index} color={'secondary.dark'}>
        {item.label}
      </Typography>
    </CustomTooltip>
  );
};
